import { Component, OnInit } from '@angular/core';
import { BpgEventsService } from "../../bpg-events/bpg-events.service";
import { DataService } from "../../bpg-common/services/data.services";
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { DatePipe } from '@angular/common';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Component({
  selector: 'app-events-approval',
  templateUrl: './events-approval.component.html',
  styleUrls: ['./events-approval.component.css']
})

export class EventsApprovalComponent implements OnInit {


  eventName: string;

  eventStatus: string;
  eventCreateDate: Date;
  bpgName: string;
  bpgId: any;
  siteId: any;
  siteName: string;
  landingData: any;
  searchKey: any;
  status: any;
  onFirstRender = false;
  myEventList = [];
  eventsData = [];
  chapterList: any;
  tableShow: boolean;
  userAndRoleIdDTO: any;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  adminId: any = localStorage.getItem('adminId');
  chapterId: string;
  chapterIds: string;
  editButton: boolean;
  deleteButton: boolean;
  approveButton: boolean;
  rejectButton: boolean;
  viewButton: boolean;
  completeButton: boolean;
  attendanceButton: boolean;
  noDataFound: boolean;
  today: any = new Date();

  method: string;
  msg1: string;
  param: string;
  siteData: any;
  siteList: any;
  bpgList: any;
  selectedBpgsData: any;
  selectedSiteId: any = 0;
  selectedErgId: any = 0;
  selectedStatus: any;

  selectedEventsDetails: any;
  approverComment = "";

  eventDetails = [];
  iconKeyList: any;
  statusList: any;
  allSiteIds: any;
  allBpgIds: any;

  alertDeleteSuccess: boolean;
  alertCloseSuccess: boolean;
  alertCancelSuccess: boolean;
  alertCancelAllSuccess: boolean;
  bpgValue: any;

  numberOfElements: number;
  currentPage = 0;
  limit: number = ConstantValues.pageLimit;
  totalPages = 0;
  currentShowingElements: number = ConstantValues.pageLimit;

  date: any = new Date();
  currDate: any = new Date();
  previousDate: any;

  buttonType: any;
  previousButton: any;
  eventStorageData: any;
  isbpgAdmin = false;
  isbpgLeadAdmin = false;
  isNaacAdmin = false;
  tableresp: boolean;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  currentTime: any = `${new Date().getHours()}:${new Date().getMinutes()}`;
  currentDate: any = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  selectAllConstant = "Select All";

  constructor(private readonly bpgCommonService: BpgCommonService,
    private readonly bpgEventsService: BpgEventsService,
    private readonly router: Router,
    private readonly  data: DataService,
    private readonly spinner: Ng4LoadingSpinnerService,
    
    private readonly datePipe: DatePipe,
    private readonly environment: EnvironmentConfiguration
  ) { }

  ngOnInit() {
    const date1 = new Date();
    const date2 = new Date(date1.setDate(date1.getDate() - 1));
    this.previousDate = this.datePipe.transform(date2, 'yyyy-MM-dd');

    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    if (localStorage.getItem('logOutFlag') === "true") {
      this.router.navigate(['/log-out']);
    }

    this.userAndRoleIdDTO = {
      userId: this.loginData['userId'],
      roleId: localStorage.getItem('adminId')
    }


    window.scrollTo(0, 0)
    this.spinner.show();

    localStorage.removeItem('searchedEventsCaledarItems');
    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isbpgAdmin = true
    }
    if(localStorage.getItem('isbpgLeadAdmin')==='true'){
      this.isbpgLeadAdmin = true;
    }
    if(localStorage.getItem('isNaacAdmin') === 'true')
    {
      this.isNaacAdmin = true
    }
    if (this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && this.adminId !== "4" && !this.isNaacAdmin && !this.isbpgAdmin && !this.isbpgLeadAdmin) {
      this.router.navigate(['/site-home']);
    }

    this.today = this.datePipe.transform(this.date, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"); //whatever format you need. 

    this.statusList = [{ status: this.selectAllConstant }, { status: "APPROVED" }, { status: "CANCELLED" }, { status: "CLOSED" }, { status: "COMPLETED" }, { status: "NEW" },
    { status: "REJECTED" }, { status: "SUBMITTED" }]


    this.tableShow = false;
    this.data.saveData('default Message');
    this.onFirstRender = true;

    const fromDate = this.datePipe.transform(new Date, ConstantValues.dateFormats.dateFormat);
    const toDate = this.datePipe.transform(this.addDays(new Date, 365), ConstantValues.dateFormats.dateFormat);
    this.landingData = {
      "filter": {
        "chapterId": "",
        "fromDate": fromDate,
        "toDate": toDate,
        "adminId": ""
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": ConstantValues.pageLimit,
      "sortDirection": "DESC",
      "sortProperty": "event_create_date",
      "uid": ""
    }

    this.adminId = localStorage.getItem('adminId');
    this.tableShow = false;
    this.data.saveData('default Message');
    this.onFirstRender = true;
    this.spinner.show();
    this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
      this.chapterList = data;
      this.chapterList.map((i) => { i.siteName = `${i.siteName}-${i.bpgName}` ; return i; })
      if (this.chapterList.length > 1) {
        this.chapterList.unshift({ chapterId: 0, siteName: this.selectAllConstant, bpgName: '' });
      }
      for (let i = 0; i < this.chapterList.length; i++) {
        if (i === 0) {
          this.chapterIds = this.chapterList[i].chapterId;
        }
        else {
          this.chapterIds = `${this.chapterIds},${this.chapterList[i].chapterId}`;
        }
      }

      this.siteData = {
        "filter": {
          chapterId: this.chapterIds
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "",
        "searchTerm": "",
        "size": 0,
        "sortDirection": "ASC",
        "sortProperty": "",
        "uid": ""
      }
      this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
        this.siteList = data;
        //filter default site from sitelist
        this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
        this.siteList.unshift({ siteId: 0, siteName: this.selectAllConstant, bpgName: '' });
        for (let i = 0; i < this.siteList.length; i++) {
          if (i === 0) {
            this.allSiteIds = this.siteList[i].siteId;
          } else {
            this.allSiteIds = `${this.allSiteIds}${this.siteList[i].siteId},`;
          }
        }

        if (this.adminId === "1"){
          this.siteChange(0);
        }
      });
      this.selectedBpgsData =
      {
        "filter": {
          "siteId": this.siteId,
          "userId": this.userAndRoleIdDTO.userId,
          "adminId": this.userAndRoleIdDTO.roleId
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": "string",
        "size": 0,
        "sortDirection": "ASC",
        "sortProperty": "string",
        "uid": "string"
      }
      this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
        this.bpgList = data;
        if(this.bpgList.length > 1)
        {
          this.bpgList.unshift({ bpgId: 0, bpgName: this.selectAllConstant });
        }
        
        for (let i = 0; i < this.bpgList.length; i++) {
          if (i === 0) {
            this.allBpgIds = this.bpgList[i].bpgId;
          } else {
            this.allBpgIds = `${this.allBpgIds}${this.bpgList[i].bpgId},`;
          }
        }
      });

      this.landingData.filter.chapterId = this.chapterIds;
      this.landingData.filter.adminId = this.adminId;
      this.landingData.filter.userId = this.loginData['userId'];
      this.spinner.show();

      this.previousButton = sessionStorage.getItem(this.buttonType);
      if (this.previousButton === 'BACK' || this.previousButton === 'CANCEL') {
        this.eventStorageData = JSON.parse(localStorage.getItem('searchedEventList'));
        this.currentPage = this.eventStorageData.page + 1;
        this.landingData = this.eventStorageData;
        this.getAdminEventList();
        sessionStorage.removeItem(this.buttonType);
        localStorage.removeItem('searchedEventList');

        if (this.eventStorageData.filter.siteId !== undefined && this.eventStorageData.filter.siteId.length > 1) {
          this.siteId = 0;
        }
        else {
          this.siteId = this.eventStorageData.filter.siteId;
        }
        if (this.eventStorageData.filter.bpgId.length > 1) {
          this.bpgId = 0;
        }
        else {
          this.bpgId = this.eventStorageData.filter.bpgId;
        }
        this.searchKey = this.eventStorageData.searchTerm;
        if (this.eventStorageData.filter.status === null) {
          this.status = this.selectAllConstant;
        }
        else {
          this.status = this.eventStorageData.filter.status;
        }
      }
      else {
        this.spinner.show();

        this.getAdminEventList();
      }

    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });

    if (window.innerWidth < 767) {
      this.tableresp = true;
    } else {
      this.tableresp = false;
    }
    this.spinner.hide();
  }

  /** For filtering data by chapter basis
   * @class EventsApprovalComponent
   * @method chapterSelection
   * @params event
   */
  chapterSelection(event) {
    this.timeOutError = false;
    this.searchKey = "";
    this.chapterId = event.chapterId;
    this.landingData.searchTerm = "";
    this.landingData.filter.userId = this.loginData['userId'];
    if (this.chapterId === '0') {
      this.landingData.filter.chapterId = this.chapterIds;
    }
    else {
      this.landingData.filter.chapterId = this.chapterId;
    }
    this.bpgEventsService.getAllEvents(this.landingData).subscribe(data => {
      this.eventsData = data.content;
      this.numberOfElements = data.totalElements;
      if (this.eventsData.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
      } else {
        this.tableShow = true;
        this.noDataFound = false;
      }
      for (const eventData of this.eventsData) {
        eventData.startTime = this.convertTimeTo24Hours(eventData.startTime);
      }
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }



  editEvent(data) {
    data.edit = 'single';
    sessionStorage.setItem('editEventData', JSON.stringify(data));
  }
  editAllEvent(data) {
    data.edit = 'multi';
    sessionStorage.setItem('editEventData', JSON.stringify(data));
    
  }

  viewEventDetails(eventId, type) {
    if (type === "VIEW") {
      sessionStorage.setItem(this.iconKeyList, "V");
    }
    else if (type === "APPROVE") {
      sessionStorage.setItem(this.iconKeyList, "A");
    }
    else if (type === "REJECT") {
      sessionStorage.setItem(this.iconKeyList, "R");
    }
    else if (type === "DELETE") {
      sessionStorage.setItem(this.iconKeyList, "D");
    }
    else if (type === "ATTENDENCE") {
      sessionStorage.setItem(this.iconKeyList, "T");
    }
    else {
      sessionStorage.setItem(this.iconKeyList, "C");
    }

    for (const data of this.eventsData) {
      if (data.eventId === eventId) {
        this.eventDetails = data;
        sessionStorage.setItem("eventDetails", JSON.stringify(this.eventDetails));
        this.data.setApproved(type);
        localStorage.setItem('path', 'events-approval');
        this.router.navigate(['event-view-details']);
      }
    }
  }

  /** To view the report of the event data, this function calls when user clicks event report icon
 * @class EventsApprovalComponent
 * @method eventReportClick
 */
  eventReportClick(eventId) {
    sessionStorage.setItem(this.iconKeyList, "ER");

    for (const e of this.eventsData) {
      if (e.eventId === eventId) {
        this.eventDetails = e;
        sessionStorage.setItem("eventDetails", JSON.stringify(this.eventDetails));
        localStorage.setItem('path', 'events-approval');
        this.router.navigate(['event-report']);
      }
    }
  }

  /** For adding 365 days to current day
   * @class EventsApprovalComponent
   * @method addDays
   * @params Date, number
   */
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  /** For searching the table through keywords
   * @class EventsApprovalComponent
   * @method searchEvents
   */
  searchEvents() {
    this.timeOutError = false;
    this.selectedSiteId = this.siteId;
    this.selectedErgId = this.bpgId;
    this.selectedStatus = this.status;
    this.landingData.page = 0;

    this.selectedSiteId = (this.selectedSiteId) ? this.selectedSiteId : null;

    this.selectedErgId = (this.selectedErgId) ? this.selectedErgId : null;
    this.searchKey = (this.searchKey) ? this.searchKey : '';

    if (this.selectedErgId === 0 || this.selectedErgId == null) {
      this.selectedErgId = this.allBpgIds;
    }
    if (this.selectedSiteId === 0 || this.selectedSiteId == null) {
      this.selectedSiteId = this.allSiteIds;
    }
    if (this.selectedStatus === this.selectAllConstant) {
      this.selectedStatus = null;
    }

    this.landingData.filter.siteId = this.selectedSiteId;
    this.landingData.filter.bpgId = this.selectedErgId;
    this.landingData.filter.status = this.selectedStatus;
    this.landingData.filter.userId = this.loginData['userId'];
    this.landingData.filter.search = true;
    this.landingData.searchTerm = this.searchKey;

    

    this.bpgEventsService.getAllEvents(this.landingData).subscribe(data => {
      this.tableShow = true;
      this.eventsData = data.content;
      localStorage.setItem('searchedEventList', JSON.stringify(this.landingData));
      this.numberOfElements = data.totalElements;
      this.currentPage = 1;
      if (this.eventsData.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
      } else {
        this.tableShow = true;
        this.noDataFound = false;
      }
      for (const e1 of this.eventsData) {
        e1.startTime = this.convertTimeTo24Hours(e1.startTime);
      }
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }


  getAdminEventList() {
    this.timeOutError = false;
    this.bpgEventsService.getAllEvents(this.landingData).subscribe(data => {

      this.tableShow = true;
      this.eventsData = (data !== null) ? data.content : [];
      this.numberOfElements = (data !== null) ? data.totalElements : 0;
      this.spinner.hide();

      localStorage.setItem('searchedEventList', JSON.stringify(this.landingData));
      if (this.eventsData.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
      } else {
        this.tableShow = true;
        this.noDataFound = false;
        this.spinner.hide();
      }
      for (const e3 of this.eventsData) {
        e3.startTime = this.convertTimeTo24Hours(e3.startTime);
      }
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });

  }

  /** For clearing edit event data
    * @class EventsApprovalComponent
    * @method clearEditEventData
    */
  public clearEditEventData() {
    sessionStorage.setItem('editEventData', null);
  }

  /** For changing event status to closed
     * @class EventsApprovalComponent
     * @method changeEventStatus
     */
  changeEventStatus(type) {
    this.timeOutError = false;
    switch (type) {
      /*for soft-delete on database*/
      case 'DELETED': this.landingData.approvalComment = this.approverComment;
        this.landingData.approvedBy = this.adminId;
        this.landingData.eventStatus = 'DELETED';
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.alertDeleteSuccess = true;
        setTimeout(function () {
          window.location.reload();
          this.alertDeleteSuccess = false;
        }.bind(this), 2500);
        break;

      /*for changing status to close*/
      case 'CLOSED': this.landingData.approvalComment = this.approverComment;
        this.landingData.approvedBy = this.adminId;
        this.landingData.eventStatus = 'CLOSED';
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.alertCloseSuccess = true;
        setTimeout(function () {
          window.location.reload();
          this.alertCloseSuccess = false;
        }.bind(this), 2500);
        break;

      /*for changing status to cancelled*/
      case 'CANCELLED':
        this.landingData.eventStatus = 'CANCELLED';
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.alertCancelSuccess = true;
        setTimeout(function () {
          window.location.reload();
          this.alertCancelSuccess = false;
        }.bind(this), 2500);
        break;

              /*for changing status to cancelled*/
      case 'CANCELLEDALL':
        this.landingData.eventStatus = 'CANCELLEDALL';
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.alertCancelAllSuccess = true;
        setTimeout(function () {
          window.location.reload();
          this.alertCancelAllSuccess = false;
        }.bind(this), 2500);
        break;
    }
    this.bpgEventsService.updateEventStatus(this.landingData).subscribe(_data => {
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  /** To close the event, this function calls when user clicks close icon
   * @class EventsApprovalComponent
   * @method completeClick
   */
  completeClick(eventId) {
    this.method = "changeEventStatus";
    this.param = 'CLOSED'
    this.msg1 = " Closing event will prevent further actions(Claim/Survey) on the event. Are you sure you want to continue? ";
    this.landingData.eventId = eventId;
  }

  /** To delete the event data, this function calls when user clicks delete icon
   * @class EventsApprovalComponent
   * @method deleteClick
   */
  deleteClick(eventId) {
    this.method = "changeEventStatus";
    this.param = "DELETED";
    this.msg1 = " Are you sure you want to delete this event ? ";
    this.landingData.eventId = eventId;
  }

  /** To cancel the event data, this function calls when user clicks calcel icon
   * @class EventsApprovalComponent
   * @method cancelClick
   */
  cancelClick(eventId) {
    this.method = "changeEventStatus";
    this.param = "CANCELLED";
    this.msg1 = " Are you sure you want to cancel this event ? ";
    this.landingData.eventId = eventId;
  }

   /** To cancel all the event data, this function calls when user clicks calcel icon
   * @class EventsApprovalComponent
   * @method cancelClick
   */
  cancelAllClick(eventId, eventGroupId) {
    this.method = "changeEventStatus";
    this.param = "CANCELLEDALL";
    this.msg1 = " Are you sure you want to cancel this entire event series ? ";
    this.landingData.eventId = eventId;
    this.landingData.eventGroupId = eventGroupId;
 
   }
  /** For site change from site list 
 * @class EventsApprovalComponent
 * @method siteChange
 * @returns Promise
 */
  public siteChange(event) {
    this.bpgList = [];
    this.selectedErgId = null;
    this.bpgValue = null;

    if (event !== undefined) {
      this.selectedSiteId = event.siteId;
    } else {
      this.selectedSiteId = 0;
      this.selectedSiteId = null;
    }

    this.selectedBpgsData =
    {
      "filter": {
        "siteId": this.selectedSiteId,
        "userId": this.userAndRoleIdDTO.userId,
        "adminId": this.userAndRoleIdDTO.roleId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgList = data;
      this.bpgList.unshift({ bpgId: 0, bpgName: this.selectAllConstant });
      for (let i = 0; i < this.bpgList.length; i++) {
        if (i === 0) {
          this.allBpgIds = this.bpgList[i].bpgId;
        } else {
          this.allBpgIds = `${this.allBpgIds}${this.bpgList[i].bpgId},`;
        }
      }
    });
  }

  /** For bpg change from bpg list 
 * @class EventsApprovalComponent
 * @method bpgChange
 * @returns Promise
 */

  bpgChange(event) {
    if (event !== undefined) {
      this.selectedErgId = event.bpgId;
    } else {
      this.selectedErgId = null;
    }
  }

  /** For bpg change from bpg list 
 * @class EventsApprovalComponent
 * @method bpgChange
 * @returns Promise
 */

  changeStatus(event) {
    if (event !== undefined) {
      this.selectedStatus = event.status;
    } else {
      this.selectedStatus = null;
    }
  }

  /** For filtering data by current page 
   * @class ChapterComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {

    this.landingData.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) <= this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) > this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getAdminEventList();
  }

  /** For sorting the table through columns
   * @class SiteComponent
   * @method sortMe
   */

  public sortMe(sortingby) {
    if (this.landingData.sortDirection === "ASC") {
      this.landingData.sortDirection = "DESC";
      document.getElementById(sortingby + "1").classList.add("fading");
      document.getElementById(sortingby + "2").classList.remove("fading");
    } else {
      this.landingData.sortDirection = "ASC";
      document.getElementById(sortingby + "2").classList.add("fading");
      document.getElementById(sortingby + "1").classList.remove("fading");
    }

    this.landingData.sortProperty = sortingby;
    this.getAdminEventList();
  }

  convertTimeTo24Hours(time) {

    let hours = Number(time.match(/^(\d+)/)[1]);
    const minutes = Number(time.match(/:(\d+)/)[1]);
    const AMPM = time.match(/\s([^\s]*)$/)[1];
    if (AMPM === "PM" && hours < 12) {hours = hours + 12;}
    if (AMPM === "AM" && hours === 12) {hours = hours - 12;}
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if (hours < 10) {sHours = "0" + sHours;}
    if (minutes < 10) {sMinutes = "0" + sMinutes;}
    return `${sHours}:${sMinutes}`;

  }

}


